function rateUsFormThankYouTemplate () {

	return `<h1>Thank You!</h1>
			<p>Your review and comments have been submitted.</p>
			<p>If you left a contact e-mail address with your review, it will only be used to respond to any questions or comments you provided with your rating.</p>`;

}
export default rateUsFormThankYouTemplate;
